var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-list',{attrs:{"content-type":"playlists","content-type-singular":"playlist","content-name":"Playlists","content-name-singular":"Playlist"}})}
var staticRenderFns = []

export { render, staticRenderFns }